'use client';

import { Suspense } from 'react';
import { SessionProvider } from 'next-auth/react';

import { Signin } from '@preventx/prismic-services';

const Page = () => (
  <Suspense>
    <SessionProvider>
      <Signin />
    </SessionProvider>
  </Suspense>
);

export default Page;
